import AssignmentListOrphanProjectAdmin from '../Contents/Operations/Assignments/OrphanedAssignment/AssignmentListOrphanProjectAdmin';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import React from 'react';

export default class OrphanedAssignmentsProjectGroupedByClientItem {
  constructor(item) {
    if (item) {
      this.ClientId = item.clientId;
      this.ClientName = item.clientName;
      this.AssignmentsCount = item.assignmentsCount;
      return;
    }
    this.ClientId = '';
    this.ClientName = '';
    this.AssignmentsCount = '';
  }

  static nameOfTheItemDetailList(item) {
    return `Orphaned - Missing Project (Client ID: ${item.ClientId})`;
  }

  static NameOfTheIdField() {
    return 'ClientId';
  }

  static Currency() {}

  static CurrencySecondary() {}

  static FieldsToShowInListTable = [
    {
      tabName: 'Assignments',
      tabLabel: 'Assignments',
      icon: 'fa-brands fa-grav fa-2x',
      data: [
        {
          name: OrphanedAssignmentsProjectGroupedByClientItem.getAssignmentContent,
          label: 'Assignments',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Client',
        orderById: 'ClientName',
        data: 'ClientName',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      { label: 'Assignments Count', orderById: 'AssignmentsCount', data: 'AssignmentsCount', minWidth: 40 },
    ];
  }

  static getAssignmentContent(item) {
    return <AssignmentListOrphanProjectAdmin clientId={item.ClientId} />;
  }
}
